import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    clientname: {
      validations: [
        { type: 'required', message: 'The field is required.'}
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'The field is required.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'The field is required.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'The field is required.' }
      ]
    },
    eventDate: {
      validations: []
    },
    plannedguestcount: {
      validations: [ 
        { type: 'required', message: 'The field is required.' }
      ]
    },
    sitecity: {
      validations: []
    }, 
    category: {
      validations: []
    },   
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Your Name',
            mapping: 'clientname',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Your Email',
            mapping: 'email',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number',
            mapping: 'telNumber',
            customClasses: ['no-label']
          },
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date',
            mapping: 'eventDate',
            customClasses: ['no-label']
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Select Event Type',
            options: [
              { label: 'Holiday' , value: 'Holiday'},
              { label: 'Private Party', value: 'Private Party'},
              { label: 'Corporate Party', value: 'Corporate Party'}
            ],
            mapping: 'theme',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Number Of Guests',
            mapping: 'plannedguestcount',
            customClasses: ['no-label']
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type Of Service',
            options: [
              { label: 'Full Service/Staff Required', value: 'Full Service/Staff Required'},
              { label: 'Pick-Up order', value: 'Pick-Up order'},                                          
              { label: 'Drop-Off/Delivery', value: 'Drop-Off/Delivery'}
            ],
            mapping: 'category',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'If you select delivery, what city do you want it delivered to ?',
            mapping: 'sitecity',
            customClasses: ['no-label']
          }
        ]
      },   
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Any Comments Or Questions ?',
            mapping: 'notes',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Tall Guy and A Grill Private Parties',
    formId: '337',
    clientKey: '4BFD6591-BD76-4F2D-806B-9F0B432D14BF',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// c:/_Development/Web Inquiry/inquiry-renderer/client_forms/tallguyandgrill1/form_structure.js